module.exports = __webpack_public_path__ + "img/earth_lights_2048.7ccf9db7.png";